<template>
  <div v-if="listaAfiliados.length > 0" class="ds-panel-store">
    <p class="ds-panel-store__title anuncio-title" style="margin-left: 0px;">Publicidad:</p>
    <a v-for="producto in listaAfiliados" :key="producto.id" :href="producto.url" target="_blank" class="ds-panel-store__item center">
      <img class="ds-panel-store__item__img" :src="producto.image" :alt="producto.title">
      <p class="ds-panel-store__item__name">{{ producto.title }}</p>
    </a>
  </div>
  <div v-else class="ds-panel-store">
    <app-block-loading :time-loading="3500"/>
  </div>
</template>

<script>
  // api
  import apiAnuncios from '@/api/Anuncios.js'

  export default {
    data() {
      return {
        listaAfiliados: [],
      }
    },
    methods: {
      loadProductos: function () {
        console.log('bloque anuncios...');
        apiAnuncios.listaProductosAfiliados(1, 'dspanel').then(
          (response) => {
            this.listaAfiliados = response.data.results
          }
        ).catch(
          (error) => {
            this.listaAfiliados = []
          }
        )
      }
    },
    beforeMount () {
      this.$methods.dsAfterCompile(this.loadProductos, 3000);
    },
  }
</script>

<style lang="scss" scoped>
  .ds-panel-store {
    margin-top: 1em;
    padding: 10px;
    &__title {
      display: block;
      margin-bottom: 10px;
    }
    &__item {
      box-shadow: 2px 2px 2px 0px rgba(185, 185, 185, 0.75);
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      text-decoration: none;
      margin-bottom: 10px;
      width: 80%;
      height: 50px;
      overflow: hidden;
      border-bottom: 1px solid #fdcb6e;
      border-right: 1px solid #fdcb6e;
      &:hover {
        cursor: pointer;
        opacity: 0.6;
      }
      &__img {
        display: block;
        width: 30%;
        height: 50px;
        
      }
      &__name {
        padding-left: 5px;
        width: 70%;
        text-align: center;
        font-size: 13px;
        font-family: $ff-1;
        font-weight: bold;
        color: $color-1;
        text-transform: capitalize;
      }
    }
  }
</style>